import { createFileRoute } from "@tanstack/react-router";

import MUserListPage from "/src/routes/muser/list";
import { mUserListSearchSchema } from "/src/routes/muser/list/muserListSearch";

export type { MUserListSearch } from "/src/routes/muser/list/muserListSearch";

export const Route = createFileRoute("/_main/muser")({
  validateSearch: mUserListSearchSchema,
  component: MUserListPage,
});
